module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/stopper-mobile-bg-2610c77ca1d4aa4919948f9823a53dea.png";